import type { ExtractPropTypes, PropType } from 'vue'
import type { SystemOption } from './types'

export const dataSourceProps = {
  height: {
    type: [String, Number] as PropType<string | number>,
    default: 420,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showDetail: {
    type: Boolean,
    default: true,
  },
  showSchema: {
    type: Boolean,
    default: true,
  },
  systemOptions: {
    type: Array as PropType<SystemOption[]>,
    default: undefined,
  },
} as const

export type DataSourceProps = ExtractPropTypes<typeof dataSourceProps>

export const dataSourceEmits = {
  saved: () => true,
}
